import React from 'react';
import { motion } from 'framer-motion';
import { Leaf, TrendingUp, MessageCircle, ShieldCheck, ArrowRight } from 'lucide-react';
const anim = (d: number = 0) => ({
  initial: {
    opacity: 0,
    y: 16
  },
  whileInView: {
    opacity: 1,
    y: 0
  },
  viewport: {
    once: true,
    margin: '-40px'
  },
  transition: {
    duration: 0.3,
    delay: d,
    ease: 'easeOut' as const
  }
});
export function ValueProposition() {
  const benefits = [{
    icon: Leaf,
    title: '100% personalizado',
    desc: 'Un nutriólogo analiza TUS hábitos y diseña un plan para TI. No es una plantilla genérica.'
  }, {
    icon: TrendingUp,
    title: 'Seguimiento profesional',
    desc: 'No te damos un PDF y desaparecemos. Tienes consultas regulares y ajustes según tus resultados.'
  }, {
    icon: MessageCircle,
    title: 'WhatsApp incluido',
    desc: 'Tu nutriólogo te responde dudas entre sesiones. No estás solo.'
  }, {
    icon: ShieldCheck,
    title: 'Sin prohibiciones',
    desc: 'Aprendes a comer mejor, no a dejar de comer. Sin eliminar grupos de alimentos ni pasar hambre.'
  }];
  return <section className="bg-dark py-12 lg:py-24 overflow-hidden" data-id="element-302">
      <div className="max-w-[1400px] mx-auto px-5 md:px-12 lg:px-[72px]" data-id="element-303">
        <div className="text-center mb-10 lg:mb-16 max-w-[800px] mx-auto" data-id="element-304">
          <h2 className="font-serif italic text-[28px] md:text-[44px] leading-[1.15] text-primary" data-id="element-305">
            No vendemos dietas. Vendemos planes que funcionan en tu vida real.
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 lg:gap-6 mb-12" data-id="element-306">
          {benefits.map((ben, idx) => <motion.div key={idx} {...anim(idx * 0.08)} className="bg-primary/5 border border-primary/10 rounded-2xl p-6 flex flex-col items-start" data-id="element-307">
              <ben.icon className="w-8 h-8 text-accent-secondary mb-4 stroke-[1.5]" data-id="element-308" />
              <h3 className="font-sans text-[16px] font-bold text-primary mb-2 leading-tight" data-id="element-309">
                {ben.title}
              </h3>
              <p className="font-sans text-[14px] font-light text-primary/70 leading-[1.6]" data-id="element-310">
                {ben.desc}
              </p>
            </motion.div>)}
        </div>

        <motion.div {...anim(0.3)} className="text-center" data-id="element-311">
          <motion.button whileTap={{
          scale: 0.96
        }} className="w-full sm:w-auto border border-primary text-primary uppercase text-[13px] font-bold tracking-wide py-4 px-8 rounded-full flex items-center justify-center space-x-2 min-h-[52px] hover:bg-primary hover:text-dark transition-all group mx-auto" data-id="element-312">
            <span data-id="element-313">Conocer los planes</span>
            <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" data-id="element-314" />
          </motion.button>
        </motion.div>
      </div>
    </section>;
}